import React from 'react'

// motion
import { motion } from 'framer-motion'

// Variant
import { fadeIn } from '../variants'

import img1 from '../assets/image.png'
import img2 from '../assets/image2.png'
import img3 from '../assets/portfolio-img2.png'

const Work = () => {
  return (
    <div id="work" className="lg:mt-[500px] mt-[150px] section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10">
          <div className="flex flex-1 flex-col gap-y-12 mb-10 lg:mb-0 ">
            {/* text */}
            <div>
              <h2 className="h2 leading-tight text-accent font-extrabold ">
                My latest <span>Projects</span>
              </h2>
              <p className="max-w-sm md:max-w-full lg:mb-[150px] mb-26 sm:mb-[90px] lg:text-2xl">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
                vel qui ipsa maiores eos doloremque amet labore eligendi, nihil
                exercitationem blanditiis aut aspernatur quos dolorum possimus
                est rerum enim eum!
              </p>
            </div>
            {/* image */}
            <div
              className="group relative h-[300px] lg:h-[350px] overflow-hidden border-2 border-white/20 rounded-xl"
            >
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 translation-all duration-300"></div>

              {/* images preview */}

              <img
                src={img1}
                alt="website-image"
                className="group-hover:scale-[125%] translation-all duration-500 w-full "
              />

              {/* pretitle */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-[230px] lg:group-hover:bottom-[250px] transition-all duration-500 z-[50]">
                <span className="text-gradient font-extrabold text-2xl lg:">
                  Web App
                </span>
              </div>

              {/* Project title */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-11 transition-all duration-700 z-[50]">
                <span className="text-2xl lg:text-3xl text-white">
                  Responsive single page foodApp built with React.js and styled
                  with tailwind.css. It filters food based on selected choices{' '}
                  <br />
                  <a href="https://food-app-weld-rho.vercel.app/">
                    <span className="btn bt text-[15px] p-2">View</span>
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* side col */}

          
          <div className="flex-1 flex flex-col gap-y-10">
            {/* image side view 1 */}
            <div
              className="group relative h-[300px] lg:h-[350px] overflow-hidden border-2 border-white/20 rounded-xl"
            >
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 translation-all duration-300"></div>

              {/* images preview */}

              <img
                src={img2}
                alt="website-image"
                className="group-hover:scale-[125%] translation-all duration-500 w-full h-[300px] lg:h-[350px]"
              />

              {/* pretitle */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-[230px] lg:group-hover:bottom-[250px] transition-all duration-500 z-[50]">
                <span className="text-gradient font-extrabold text-2xl lg:">
                  Web App
                </span>
              </div>

              {/* Project title */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-8 transition-all duration-700 z-[50]">
                <span className="text-2xl lg:text-3xl text-white">
                  Have you ever had money and all of a sudden its gone? well
                  this web app helps you keep track of all your expenses.
                  <br />
                  <a href="https://food-app-weld-rho.vercel.app/">
                    <span className="btn bt text-[15px] p-2">View</span>
                  </a>
                </span>
              </div>
            </div>

            {/* image side view 2 */}
            <div
              className="group relative h-[300px] lg:h-[350px] overflow-hidden border-2 border-white/20 rounded-xl"
            >
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 translation-all duration-300"></div>

              {/* images preview */}

              <img
                src={img3}
                alt="website-image"
                className="group-hover:scale-[125%] translation-all duration-500 w-full h-[300px] lg:h-[350px] "
              />

              {/* pretitle */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-[230px] lg:group-hover:bottom-[250px] transition-all duration-500 z-[50]">
                <span className="text-gradient font-extrabold text-2xl lg:text-2xl">
                  Web App
                </span>
              </div>

              {/* Project title */}
              <div className="absolute -bottom-full left-9 group-hover:bottom-11 transition-all duration-700 z-[50]">
                <span className="text-2xl lg:text-3xl text-white">
                  COMING SOON...
                  <br />
                  <a href="#">
                    {/* <span className="btn bt text-[15px] p-2">View</span> */}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Work
